(() => {
  function preparePhoto(image) {
    image.dataset.ncReviewPhoto = '';
    image.tabIndex = 0;
    image.setAttribute('role', 'button');
    image.setAttribute('aria-label', image.alt);
    image.setAttribute('aria-haspopup', 'dialog');
  }
  function initPhotoViewer() {
    const root = document.querySelector('#namorra-concept');
    const dialog = root?.querySelector('[data-review-photo-dialog]');
    if (!dialog) return;
    root.querySelectorAll('.nc-review-card > img').forEach(preparePhoto);
    if (dialog.dataset.initialized) return;
    dialog.dataset.initialized = 'true';
    const preview = dialog.querySelector('[data-review-photo-preview]');
    let activePhoto;
    function openPhoto(image) {
      const source = image.dataset.reviewFullSrc || image.currentSrc || image.src;
      if (!/^https:\/\//.test(source)) return;
      activePhoto = image;
      preview.alt = image.alt;
      preview.src = source;
      dialog.setAttribute('aria-label', image.alt);
      dialog.showModal();
      document.documentElement.classList.add('nc-review-photo-open');
    }
    root.addEventListener('click', event => {
      const image = event.target.closest('[data-nc-review-photo]');
      if (!image || !root.contains(image)) return;
      event.preventDefault();
      openPhoto(image);
    });
    root.addEventListener('keydown', event => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      const image = event.target.closest('[data-nc-review-photo]');
      if (!image || !root.contains(image)) return;
      event.preventDefault();
      openPhoto(image);
    });
    dialog.querySelector('[data-review-photo-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('nc-review-photo-open');
      preview.removeAttribute('src');
      activePhoto?.focus({preventScroll: true});
    });
    preview.addEventListener('error', () => {
      const fallback = activePhoto?.currentSrc || activePhoto?.src;
      if (fallback && preview.src !== fallback) preview.src = fallback;
    });
  }
  function init() {
    initPhotoViewer();
    const section = document.querySelector('#nc-reviews');
    const button = section?.querySelector('[data-review-more]');
    if (!button || button.dataset.initialized) return;
    button.dataset.initialized = 'true';
    const config = JSON.parse(section.querySelector('[data-review-config]').textContent);
    const list = section.querySelector('.nc-review-highlights');
    const status = section.querySelector('[data-review-status]');
    const seen = new Set([...list.querySelectorAll('[data-review-id]')].map(card => card.dataset.reviewId));
    const queued = new Set();
    const pictures = new Set([...list.querySelectorAll('img')].map(img => img.src.split('?')[0]));
    const queue = [];
    let page = 1, otherPage = 1, phase = 'primary', busy = false;
    const plain = html => new DOMParser().parseFromString(String(html || ''), 'text/html').body.textContent.trim();
    function card(review) {
      const article = document.createElement('article');
      article.className = 'nc-review-card jm-review-namorra';
      article.dataset.reviewId = review.uuid;
      const picture = (review.pictures_urls || []).find(p => {
        const url = p.compact || p.original || '';
        return /^https:\/\//.test(url) && !pictures.has(url.split('?')[0]);
      });
      const photo = picture?.compact || picture?.original;
      if (photo) {
        const image = document.createElement('img');
        image.src = photo;
        image.alt = config.photo.replace('[name]', review.reviewer_name || '');
        image.loading = 'lazy';
        image.referrerPolicy = 'no-referrer';
        image.width = 100;
        image.height = 100;
        image.dataset.reviewFullSrc = /^https:\/\//.test(picture.original || '') ? picture.original : photo;
        preparePhoto(image);
        article.append(image);
        pictures.add(photo.split('?')[0]);
      }
      const content = document.createElement('div');
      const stars = document.createElement('div');
      const rating = Math.max(0, Math.min(5, Math.round(Number(review.rating) || 0)));
      stars.className = 'nc-review-stars';
      stars.setAttribute('role', 'img');
      stars.setAttribute('aria-label', config.stars.replace('[rating]', rating));
      stars.textContent = '★'.repeat(rating) + '☆'.repeat(5 - rating);
      const quote = document.createElement('blockquote');
      quote.textContent = plain(review.body_html || review.body || review.title);
      const author = document.createElement('span');
      author.textContent = (review.reviewer_name || '') + (review.verified_buyer ? ' · ' + config.verified : '');
      content.append(stars, quote, author);
      article.append(content);
      return article;
    }
    async function fetchPage() {
      const secondary = phase === 'other';
      const params = new URLSearchParams({shop_domain: config.shop, platform: 'shopify', product_id: String(config.product), page: String(page), per_page: '10', sort_by: 'created_at', sort_dir: 'desc', primary_language: config.language});
      params.set(secondary ? 'skip_primary_language' : 'skip_other_languages', 'true');
      if (secondary) params.set('other_language_page', String(otherPage));
      const response = await fetch('https://api.judge.me/reviews/reviews_for_widget?' + params, {signal: AbortSignal.timeout(15000), credentials: 'omit'});
      if (!response.ok) throw new Error('Reviews unavailable');
      const data = await response.json();
      if (String(data.product_external_id) !== String(config.product)) throw new Error('Product mismatch');
      const reviews = secondary ? data.other_language_reviews : data.primary_language_reviews;
      const pagination = secondary ? data.other_language_pagination : data.primary_language_pagination;
      if (!Array.isArray(reviews) || !pagination) throw new Error('Invalid reviews response');
      for (const review of reviews) {
        if (!review.uuid || seen.has(review.uuid) || queued.has(review.uuid) || review.is_for_product_from_group || review.is_for_product_from_bundle) continue;
        queued.add(review.uuid);
        queue.push(review);
      }
      const current = secondary ? otherPage++ : page++;
      if (!reviews.length || current >= Number(pagination.total_pages)) phase = secondary ? 'done' : 'other';
    }
    button.addEventListener('click', async () => {
      if (busy) return;
      busy = true;
      button.disabled = true;
      button.textContent = config.loading;
      section.setAttribute('aria-busy', 'true');
      status.textContent = '';
      try {
        while (queue.length < 10 && phase !== 'done') await fetchPage();
        const batch = queue.splice(0, 10);
        const fragment = document.createDocumentFragment();
        for (const review of batch) {
          fragment.append(card(review));
          seen.add(review.uuid);
        }
        const x = window.scrollX, y = window.scrollY;
        list.append(fragment);
        window.scrollTo({left: x, top: y, behavior: 'instant'});
        status.textContent = config.added.replace('[count]', batch.length);
        button.hidden = phase === 'done' && !queue.length;
      } catch {
        status.textContent = config.error;
      } finally {
        busy = false;
        button.disabled = false;
        button.textContent = config.more;
        section.removeAttribute('aria-busy');
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

